let state = {
    userName: ""
}

export default state